import { render, staticRenderFns } from "./ReferenceChild.vue?vue&type=template&id=46950657&scoped=true&"
import script from "./ReferenceChild.vue?vue&type=script&lang=ts&"
export * from "./ReferenceChild.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46950657",
  null
  
)

export default component.exports